import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPaperPlane } from 'react-icons/fa';
import ContactForm from '../contact-form/contact-form';
import './contact-trigger.scss';

const ContactTrigger = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <>
      <motion.button
        className="contact-trigger"
        onClick={openForm}
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ 
          type: "spring",
          damping: 15,
          stiffness: 200,
          delay: 1
        }}
        whileHover={{ 
          scale: 1.1,
          boxShadow: "0 8px 25px rgba(251, 191, 36, 0.4)"
        }}
        whileTap={{ scale: 0.95 }}
        transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }
        }}
      >
        <motion.div
          className="trigger-icon"
          animate={{
            rotate: [0, 10, -10, 0],
            scale: [1, 1.1, 1]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <FaPaperPlane />
        </motion.div>
        
        <motion.div
          className="trigger-text"
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1.5 }}
        >
          <span>Оставить заявку</span>
        </motion.div>

        {/* Floating notification dots */}
        <motion.div
          className="notification-dot"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [1, 0.7, 1]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </motion.button>

      <ContactForm isOpen={isFormOpen} onClose={closeForm} />
    </>
  );
};

export default ContactTrigger;
